import {
  Action_GetDMStore,
  Action_GetDMStoreSuccess,
  Action_GetDMCategories,
  Action_GetDMCategoriesSuccess,
  Action_GetDMCategories1,
  Action_GetDMCategoriesSuccess1,
  Action_GetDMCategoriesBaoGia,
  Action_GetDMCategoriesBaoGiaSuccess,
  Action_GetDMGroupCustomers,
  Action_GetDMGroupCustomersSuccess,
  Action_GetDMBank,
  Action_GetDMBankSuccess,
  Action_GetConfigByKey,
  Action_GetConfigByKeySuccess,
  Action_GetConfigAllSTKey,
  Action_GetConfigAllSTKeySuccess,
  Action_GetThongTinFormIn,
  Action_GetThongTinFormInSuccess
} from "./actionTypes";
// danh mục all stkey
export const Index_GetConfigAllSTKey = (data) => ({
  type: Action_GetConfigAllSTKey,
  payload: data
});
export const Index_GetConfigAllSTKeySuccess = (data) => ({
  type: Action_GetConfigAllSTKeySuccess,
  payload: data,
});
// danh mục group Config
export const Index_getConfigByKey = (data) => ({
  type: Action_GetConfigByKey,
  payload: data
});
export const Index_getConfigByKeySuccess = (data) => ({
  type: Action_GetConfigByKeySuccess,
  payload: data,
});
// danh mục group Store
export const Index_getDMStore = (data) => ({
  type: Action_GetDMStore,
  payload: data
});
export const Index_getDMStoreSuccess = (data) => ({
  type: Action_GetDMStoreSuccess,
  payload: data,
});
// danh mục category
export const Index_GetDMCategories = (data) => ({
  type: Action_GetDMCategories,
  payload: data
});
export const Index_GetDMCategoriesSuccess = (data) => ({
  type: Action_GetDMCategoriesSuccess,
  payload: data,
});

export const Index_GetDMCategories1 = (data) => ({
  type: Action_GetDMCategories1,
  payload: data
});
export const Index_GetDMCategoriesSuccess1 = (data) => ({
  type: Action_GetDMCategoriesSuccess1,
  payload: data,
});

export const Index_GetDMCategoriesBaoGia = (data) => ({
  type: Action_GetDMCategoriesBaoGia,
  payload: data
});
export const Index_GetDMCategoriesBaoGiaSuccess = (data) => ({
  type: Action_GetDMCategoriesBaoGiaSuccess,
  payload: data,
});
// danh mục Customers
export const Index_GetDMGroupCustomers = (data) => ({
  type: Action_GetDMGroupCustomers,
  payload: data
});
export const Index_GetDMGroupCustomersSuccess = (data) => ({
  type: Action_GetDMGroupCustomersSuccess,
  payload: data,
});
// danh mục group Store
export const Index_getDMBank = (data) => ({
  type: Action_GetDMBank,
  payload: data
});
export const Index_getDMBankSuccess = (data) => ({
  type: Action_GetDMBankSuccess,
  payload: data,
});
// thông tin form in
export const Index_GetThongTinFormIn = (data) => ({
  type: Action_GetThongTinFormIn,
  payload: data
});
export const Index_GetThongTinFormInSuccess = (data) => ({
  type: Action_GetThongTinFormInSuccess,
  payload: data,
});